import React, { useEffect, useState } from "react";
import {
  Box,
  Stack,
  Divider,
  Typography,
  Link,
  styled,
  Avatar,
  Menu,
  MenuItem,
  ListItemIcon,
  Tooltip,
  IconButton,
} from "@mui/material";
import { Outlet, useNavigate } from "react-router-dom";
import Logout from "@mui/icons-material/Logout";
import PermIdentityIcon from '@mui/icons-material/PermIdentity';
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useApp } from "../context/AppContext";

const VerticalLine = styled(Divider)(({ theme }) => ({
  backgroundColor: "#fff",
  width: "2px",
  height: "auto",
}));

const OrganizationLayout = () => {
  const navigate = useNavigate();
  const { userDetails, logout } = useApp();
  const [userInfo, setUserInfo] = useState(userDetails);

  useEffect(()=>{
    setUserInfo(userDetails);
  }, [userDetails])

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  
  const handleLogout = () => {
    logout();
    navigate('/')
    setAnchorEl(null);
  };

  const handleProfileNavigation = () => {
    let editorJobTitles = ["editor", "videographer/editor", "video editor", "animator/editor"];
    if(userDetails.role == 'admin' && userDetails.jobTitle && editorJobTitles.includes(userDetails.jobTitle.toLowerCase())){
      navigate(`/editor/profile`);
    } else {
      navigate(`/profile`);
    }
    // navigate(`/payments/list/${userDetails._id}`)
    setAnchorEl(null);
  };

  return (
    <Box backgroundColor="rgb(28, 47, 65)">
      <Stack
        paddingX={4}
        paddingY={2}
        direction={"row"}
        justifyContent={"space-between"}
      >
        <Box display={"flex"} gap={2}>
          <img
            src="/images/logo.png"
            style={{ width: "64px", height: "35px" }}
          ></img>
          <VerticalLine />
          <Typography variant="h1" color="#fff">
            SNAPSHOT VIDEOS
          </Typography>
        </Box>
        {userInfo && Object.keys(userInfo).length > 0 && (
          <Stack direction={"row"} alignItems={"center"}>
            <Stack direction={"row"} gap={2} alignItems={"center"}>
              <Typography
                color="#fff"
                sx={{ cursor: "pointer" }}
                onClick={() => {
                  navigate("/organization/list");
                }}
              >
                Organization
              </Typography>
              <VerticalLine sx={{ height: "30px" }} />
              <Box>
                <Tooltip title="Account settings">
                  <IconButton
                    onClick={handleClick}
                    size="small"
                    sx={{ mr: 2 }}
                    aria-controls={open ? "account-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? "true" : undefined}
                  >
                    <Avatar sx={{ width: 32, height: 32 }}>
                      {/* <AccountCircleIcon fontSize="large" color='#bdbdbd'/> */}
                      <img src="/images/admin.jpg" />
                    </Avatar>
                  </IconButton>
                </Tooltip>
                <Menu
                  anchorEl={anchorEl}
                  id="account-menu"
                  open={open}
                  onClose={handleClose}
                  onClick={handleClose}
                  slotProps={{
                    paper: {
                      elevation: 0,
                      sx: {
                        overflow: "visible",
                        filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                        mt: 1.5,
                        "& .MuiAvatar-root": {
                          width: 32,
                          height: 32,
                          ml: -0.5,
                          mr: 1,
                        },
                        "&::before": {
                          content: '""',
                          display: "block",
                          position: "absolute",
                          top: 0,
                          right: 14,
                          width: 10,
                          height: 10,
                          bgcolor: "background.paper",
                          transform: "translateY(-50%) rotate(45deg)",
                          zIndex: 0,
                        },
                      },
                    },
                  }}
                  transformOrigin={{ horizontal: "right", vertical: "top" }}
                  anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                >
                  <MenuItem onClick={handleProfileNavigation}>
                    <ListItemIcon>
                      <PermIdentityIcon fontSize="small" />
                    </ListItemIcon>
                    Profile
                  </MenuItem>
                  <MenuItem onClick={handleLogout}>
                    <ListItemIcon>
                      <Logout fontSize="small" />
                    </ListItemIcon>
                    Logout
                  </MenuItem>
                </Menu>
              </Box>
            </Stack>
          </Stack>
        )}
      </Stack>
      <main>
        <Outlet />
      </main>
    </Box>
  );
};

export default OrganizationLayout;
